import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { logoutUser } from './authSlice';

const dummyHistory = [
  { id: 1, couponCode: 'xxxxxxxxxxx', clientId: 'xxxxxxx1', type: '100', issueDate: '2025-11-22', expiryDate: null, status: '使用済み' },
  { id: 2, couponCode: 'xxxxxxxxxxx', clientId: 'xxxxxxx1', type: '500', issueDate: '2025-11-22', expiryDate: null, status: '使用済み' },
  { id: 3, couponCode: 'xxxxxxxxxxx', clientId: 'xxxxxxx2', type: '500', issueDate: '2025-11-22', expiryDate: null, status: '使用済み' },
  { id: 4, couponCode: 'xxxxxxxxxxx', clientId: 'xxxxxxx3', type: '100', issueDate: '2025-11-22', expiryDate: null, status: '使用済み' },
  { id: 5, couponCode: 'xxxxxxxxxxx', clientId: 'xxxxxxx7', type: 'unlimited31', issueDate: '2025-11-22', expiryDate: '2025-12-22', status: '期限切れ' },
  { id: 6, couponCode: 'xxxxxxxxxxx', clientId: 'xxxxxx25', type: 'free', issueDate: '2025-12-01', expiryDate: null, status: '使用済み' },
  { id: 7, couponCode: 'xxxxxxxxxxx', clientId: 'xxxxx124', type: 'unlimited31', issueDate: '2025-12-13', expiryDate: '2026-01-12', status: '有効' },
  { id: 8, couponCode: 'xxxxxxxxxxx', clientId: 'xxxxxxx8', type: '100', issueDate: '2025-12-15', expiryDate: null, status: '有効' },
  { id: 9, couponCode: 'xxxxxxxxxxx', clientId: 'xxxxxxx9', type: '500', issueDate: '2025-12-18', expiryDate: null, status: '有効' },
  { id: 10, couponCode: 'xxxxxxxxxxx', clientId: 'xxxxxx10', type: 'free', issueDate: '2025-12-20', expiryDate: null, status: '有効' },
];

const filterHistory = (history, filters) => {
  let filtered = [...history];

  if (filters.clientId && filters.clientId.trim() !== '') {
    const searchId = filters.clientId.toLowerCase();
    filtered = filtered.filter(item => 
      item.clientId.toLowerCase().includes(searchId)
    );
  }

  if (filters.startDate) {
    const startDate = new Date(filters.startDate);
    filtered = filtered.filter(item => {
      const issueDate = new Date(item.issueDate);
      return issueDate >= startDate;
    });
  }

  if (filters.endDate) {
    const endDate = new Date(filters.endDate);
    endDate.setHours(23, 59, 59, 999);
    filtered = filtered.filter(item => {
      const issueDate = new Date(item.issueDate);
      return issueDate <= endDate;
    });
  }

  if (filters.type && filters.type !== 'all') {
    filtered = filtered.filter(item => item.type === filters.type);
  }

  return filtered;
};

export const fetchHistory = createAsyncThunk(
  'history/fetchHistory',
  async (filters, { rejectWithValue }) => {
    try {
      await new Promise(resolve => setTimeout(resolve, 500));
      
      const filteredData = filterHistory(dummyHistory, filters || {});
      return filteredData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  historyData: [],
  filters: {
    clientId: '',
    startDate: '2025-12-01',
    endDate: '2025-12-31',
    type: 'all',
  },
  currentPage: 1,
  itemsPerPage: 10,
  isLoading: false,
  error: null,
};

const historySlice = createSlice({
  name: 'history',
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchHistory.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchHistory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.historyData = action.payload;
        state.currentPage = 1;
      })
      .addCase(fetchHistory.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(logoutUser.fulfilled, () => ({ ...initialState }));
  },
});

export const {
  setFilters,
  setCurrentPage,
  clearError,
} = historySlice.actions;

export default historySlice.reducer;
